export const AUTHENTICATION_BASE_URL = process.env.REACT_APP_AUTHENTICATION_BASE_URL;

export const AUTHENTICATION_JSONRPC_ENTRY_POINT =
  process.env.REACT_APP_AUTHENTICATION_JSONRPC_ENTRY_POINT;
